import {AjaxPost} from '../../ts/services/ajax-post';

export enum MetricTypes {
  moduleLoaded = 'moduleLoaded',
  playbackStart = 'playbackStart',
  slideActive = 'slideActive',
  teaserClicked = 'teaserClicked'
}

/**
 * Sets information about performance metrics, currently used for vertical videos
 */
export class VideoSlideshowMetric {
  private metricModuleLoadToPlaybackStartAlreadySent = false;
  private metricTeaserClickToPlaybackStartAlreadySent = false;
  private readonly metricEndpoint: string;

  constructor() {
    this.metricEndpoint = window.ui?.metrics?.endpoint || '';
  }

  /**
   * set perf mark  if module was loaded
   */
  markModuleLoaded() {
    performance.mark(MetricTypes.moduleLoaded);
  }

  /**
   * set perf mark if teaser has been clicked
   */
  markTeaserClicked() {
    performance.mark(MetricTypes.teaserClicked);
  }

  /**
   * set perf mark  if slide is active
   */
  markSlideActive() {
    performance.mark(MetricTypes.slideActive);
  }

  /**
   * set perf mark if video playback has started
   */
  markPlaybackStart() {
    performance.mark(MetricTypes.playbackStart);
  }

  measureModuleLoadToPlaybackStart() {
    return performance.measure('video_slideshow_open-video_playback_start', MetricTypes.moduleLoaded, MetricTypes.playbackStart);
  }

  measureSlideActiveToPlaybackStart() {
    return performance.measure('slide_active-video_playback_start', MetricTypes.slideActive, MetricTypes.playbackStart);
  }

  measureTeaserClickToPlaybackStart() {
    return performance.measure('teaser_click-video_playback_start', MetricTypes.teaserClicked, MetricTypes.playbackStart);
  }

  sendMetricModuleLoadToPlaybackStart() {
    if (!this.metricModuleLoadToPlaybackStartAlreadySent && performance.getEntriesByName(MetricTypes.moduleLoaded).length > 0) {
      const metric = this.measureModuleLoadToPlaybackStart();

      void AjaxPost.postJSON(this.metricEndpoint, {
        duration: metric.duration,
        type: metric.name
      });

      this.metricModuleLoadToPlaybackStartAlreadySent = true;
      performance.clearMarks(MetricTypes.moduleLoaded);
    }
  }

  sendMetricTeaserClickToPlaybackStart() {
    if (!this.metricTeaserClickToPlaybackStartAlreadySent && performance.getEntriesByName(MetricTypes.teaserClicked).length > 0) {
      const metric = this.measureTeaserClickToPlaybackStart();
      const metricPrefix = document.readyState === 'complete' ? 'page_loaded_' : '';

      void AjaxPost.postJSON(this.metricEndpoint, {
        duration: metric.duration,
        type: metricPrefix + metric.name
      });

      this.metricTeaserClickToPlaybackStartAlreadySent = true;
      performance.clearMarks(MetricTypes.teaserClicked);
    }
  }

  sendMetricSlideActiveToPlaybackStart() {
    if (performance.getEntriesByName(MetricTypes.slideActive).length > 0) {
      const metric = this.measureSlideActiveToPlaybackStart();

      void AjaxPost.postJSON(this.metricEndpoint, {
        duration: metric.duration,
        type: metric.name
      });

      performance.clearMarks(MetricTypes.slideActive);
      performance.clearMarks(MetricTypes.playbackStart);
    }
  }
}
